import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { LanguageSelector } from '../components/LanguageSelector';
import { ArrowRight } from 'lucide-react';
export function SplashScreen() {
  const navigate = useNavigate();
  const [step, setStep] = useState<'lang' | 'onboarding'>('lang');
  const [lang, setLang] = useState<'bn' | 'en'>('bn');
  const handleLangSelect = (selected: 'bn' | 'en') => {
    setLang(selected);
    setTimeout(() => setStep('onboarding'), 300);
  };
  return <div className="min-h-screen bg-white flex flex-col p-6 relative overflow-hidden" data-id="element-430">
      {/* Background decoration */}
      <div className="absolute top-[-10%] right-[-10%] w-64 h-64 bg-[#006a4e]/5 rounded-full blur-3xl opacity-50" data-id="element-431" />
      <div className="absolute bottom-[-10%] left-[-10%] w-64 h-64 bg-green-50 rounded-full blur-3xl opacity-50" data-id="element-432" />

      <div className="flex-1 flex flex-col justify-center z-10" data-id="element-433">
        <AnimatePresence mode="wait" data-id="element-434">
          {step === 'lang' ? <motion.div key="lang" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          x: -20
        }} className="space-y-8" data-id="element-435">
              <div className="text-center space-y-2" data-id="element-436">
                <div className="w-20 h-20 bg-[#006a4e] rounded-2xl mx-auto flex items-center justify-center mb-6 shadow-xl shadow-green-200" data-id="element-437">
                  <span className="text-4xl" data-id="element-438">🎫</span>
                </div>
                <h1 className="text-3xl font-bold text-gray-900" data-id="element-439">OneTicket</h1>
                <p className="text-gray-500" data-id="element-440">Bangladesh's Unified Travel App</p>
              </div>

              <div className="space-y-4" data-id="element-441">
                <p className="text-center text-gray-600 font-medium" data-id="element-442">
                  ভাষা নির্বাচন করুন / Select Language
                </p>
                <LanguageSelector selected={lang} onSelect={handleLangSelect} data-id="element-443" />
              </div>
            </motion.div> : <motion.div key="onboarding" initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} className="space-y-8 text-center" data-id="element-444">
              <div className="w-full aspect-square bg-[#006a4e]/5 rounded-3xl flex items-center justify-center mb-8" data-id="element-445">
                <img src="https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=400&q=80" alt="Travel" className="w-3/4 h-3/4 object-cover rounded-2xl shadow-lg rotate-3" data-id="element-446" />
              </div>

              <div className="space-y-3" data-id="element-447">
                <h2 className="text-3xl font-bold font-bengali text-gray-900" data-id="element-448">
                  এক অ্যাপে সব টিকিট
                </h2>
                <p className="text-gray-600 font-bengali text-lg leading-relaxed" data-id="element-449">
                  বাস, ট্রেন, লঞ্চ বা বিমান - সব টিকিট এখন এক জায়গায়। কোনো
                  ঝামেলা ছাড়াই।
                </p>
              </div>

              <button onClick={() => navigate('/home')} className="w-full bg-[#006a4e] text-white py-4 rounded-xl font-bold text-xl font-bengali flex items-center justify-center space-x-2 shadow-lg shadow-green-200 mt-8" data-id="element-450">
                <span data-id="element-451">শুরু করুন</span>
                <ArrowRight size={24} data-id="element-452" />
              </button>
            </motion.div>}
        </AnimatePresence>
      </div>
    </div>;
}